// API URL'i tanımla
export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8012/api'; // Backend API URL'inize göre değiştirin